
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gwKcna3ZjcZCapJ0bKYt_45NPS_45c0RcgFnzHl0Ts5nFrsMMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexoY_x228i1y_45a3qNHGdiLRHJkLNEYBTaxdJrR_45B6T58wMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchv_USzq0cpfrJniAd4rjvphYJz3UxNje_1W3DKeVlYmQMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexPR4DwBV5sbKbkkPlzERg5Gvjx1dNF_45f4nh_454VZozAYYMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93j665ulAn7pRDiOQwNVCQlAnvo12_YQM7ESzJTYdihwEMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexYkMv01e5KRCBCL3Rqq90lx7KHlhCTIUfWd_jf7_NtAwMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_931QkzwYZi_01CGVgrxZdlpFv2Rynj71JVuBwgMAD04bgMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexHSKVg6YjC19eASDNd05IcgEwjN8fAltNnHSp9aTcl98Meta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93KFrOb6pQICuCG9dyRzcZMu5lQJaPTQHcZUafA67_452GkMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexbdCss3fDgGpnCl81iKKZfWlV_45KAVPJi49KnakOJUUeoMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexkYGGE_45Bxyi3LJfOnAnDIWAJTMG9cbMLLQDaGvzEhckUMeta } from "/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexYkMv01e5KRCBCL3Rqq90lx7KHlhCTIUfWd_jf7_NtAwMeta || {},
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexHSKVg6YjC19eASDNd05IcgEwjN8fAltNnHSp9aTcl98Meta || {},
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexbdCss3fDgGpnCl81iKKZfWlV_45KAVPJi49KnakOJUUeoMeta || {},
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexkYGGE_45Bxyi3LJfOnAnDIWAJTMG9cbMLLQDaGvzEhckUMeta || {},
    component: () => import("/codebuild/output/src900041636/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]